export const explorer = {
  id: 167861,
  name: "root",
  isFolder: true,
  children: [
    {
      id: 167862,
      name: "images",
      isFolder: true,
      children: [
        {
          id: 167864,
          name: "images",
          link: "/images",
          isFolder: false,
        },
      ],
    },
    {
      id: 167863,
      name: "photo",
      isFolder: true,
      children: [
        {
          id: 167865,
          name: "photo",
          link: "/photo",
          isFolder: false,
        },
      ],
    },
    {
      id: 167866,
      name: "vig",
      isFolder: true,
      children: [
        {
          id: 167867,
          name: "vig",
          link: "/vig",
          isFolder: false,
        },
      ],
    },
  ],
};
